import { withModuleContext } from '@edreamsodigeo/frontend-core';
import { PrismaProvider } from '@edreamsodigeo/prisma-design-system';

import { MODULE_NAMESPACE } from '~constants';

export default withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
